export const BALANCE_KEY = 'balance';

export const INITIAL_SEND_DATETIME = 'initial_send_datetime';

export const REPEAT_SEND_DATETIMES = 'repeat_send_datetimes';

export const SHOULD_REPEAT_SEND = 'should_repeat_send';

export const SHOULD_SUBMIT_AFTER_SAVE_KEY = 'should_submit_after_save';
